module.exports = __webpack_public_path__ + "assets/rename.6868a6ae.svg";